<!-- Layout.vue -->

<template>
    <div>
        <Header />
        <main class="app-main">
            <router-view :key="$route.fullPath"></router-view>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from './include/Header.vue';
import Footer from './include/Footer.vue';

export default {
    components: {
        Header,
        Footer,
    },
};
</script>

<style scoped>
/* Reserve vertical space so the Footer can never jump up under the Header while a
   route component is still resolving/rendering (prevents a large CLS spike). */
.app-main {
    min-height: 70vh;
}
</style>
